import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { isNil } from "lodash-es";
import { ApiService } from "src/app/api/api.service";
import { ESTADOS, ESTADOS_SITIO } from "src/app/shared/constantes";
import { Result, parseError } from "src/app/shared/interfaces";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
    private config: any = { estado_sitio_id: 5, fecha_inicio: null };
    private _url = '';
    constructor(private route: ActivatedRoute, private api: ApiService) {
        this._url = environment.apiUrl
    }

    ngOnInit(): void {
        this.obtenerConfiguracionActual();
    }

    async obtenerConfiguracionActual() {
        try {
            const path = 'configuracion/actual'
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result;
            this.config = result.data;
        } catch (e) {
            console.log(parseError(e));
        }
    }

    get mostrarContador(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.CUENTA_REGRESIVA;
    }

    get nominarVotar(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.NOMINAR_VOTAR;
    }

    get mostrarCategorias(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.NOMINAR_VOTAR;
    }

    get nuevasNominaciones(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.NOMINAR_VOTAR;
    }
    get masVotado(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.NOMINAR_VOTAR;
    }

    get finalista(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.FINALISTAS;
    }

    get ganadores(): boolean {
        return this.config.estado_sitio_id === ESTADOS_SITIO.GANADORES;
    }

    get fechaFinalista(): string {
        return this.config.fecha_inicio;
    }

    get url(): string {
        return `${this._url}/uploads`;
    }

    get logoImagen(): string {
        return `${this.url}/${this.config.logo_principal}`;
    }

    get logo(): string {
        return `${this.url}/${this.config.imagen_logo}`;
    }

    get edicion(): string {
        return this.config.numero_edicion;
    }


    get backgroundUrl(): string {
        return !isNil(this.config.background) ? `${this.url}/${this.config.background}` : '';
    }

}